import { useEffect, useMemo } from 'react';
import { WebService } from '../../services/webService';
import loading from '../../js/loading';

const AutocompleteContrato = ({
   contratos = [], 
   setData, 
   iContratoRef, 
   searchContrato, 
   setSearchContrato, 
   M,
   setContratoID
}) => {

   // 1. Transformamos el array de contratos al formato de objeto que exige Materialize: { "Razón Social": null }
   const autocompleteData = useMemo(() => {
      const dataObj = {};
      if (Array.isArray(contratos)) {
         contratos.forEach((c) => {
            if (c.razonSocial) {
               dataObj[c.razonSocial] = null; // Puedes poner una URL de imagen si quisieras icono
            }
         });
      }
      return dataObj;
   }, [contratos]);

   // 2. Inicializamos Materialize Autocomplete y manejamos la selección
   useEffect(() => {
      if (iContratoRef.current && M && M.Autocomplete) {
         const options = {
            data: autocompleteData,
            limit: 10, // Límite opcional de sugerencias visibles
            onAutocomplete: async (selectedText) => {
               setSearchContrato(selectedText);
               
               // Buscamos el contrato completo para obtener su contratoID
               const contratoEncontrado = contratos.find(c => c.razonSocial === selectedText);
               setContratoID(contratoEncontrado.contratoID);
               if (contratoEncontrado) {
                  loading.startLoading();
                  try {
                     const empleados = await WebService.getEmpleadosCredenciales(contratoEncontrado.contratoID);
                     setData(empleados);
                  } catch (error) {
                     console.error("Error al obtener los empleados del contrato:", error);
                     setData([]);
                  }finally{
                     loading.closeLoading()
                  }
               }
            }
         };

         // Inicializamos el componente de Materialize sobre el input usando la ref
         const instance = M.Autocomplete.init(iContratoRef.current, options);

         // Limpieza al desmontar el componente para evitar fugas de memoria o instancias huérfanas
         return () => {
            if (instance && typeof instance.destroy === 'function') {
               instance.destroy();
            }
         };
      }
   }, [autocompleteData, contratos, M]);

   // Manejador nativo del input para actualizar el estado de texto libremente
   const handleOnChange = (e) => {
      setSearchContrato(e.target.value);
   };

   return (
      <div className="input-field col s12 m6 l6 x6">
         <input 
            autoComplete="off"
            type="text" 
            className="autocomplete form-control" // <- Clase requerida por Materialize (.autocomplete)
            aria-describedby="nombreEmpleadoHelpBlock" 
            onChange={handleOnChange}
            value={searchContrato}
            ref={iContratoRef}
            id="autocomplete-input"
            autoFocus
         />
         <label htmlFor="autocomplete-input" className="active">Razón Social</label>
      </div>
   );
};

export default AutocompleteContrato;